// extracted by mini-css-extract-plugin
export default {"subscription":"SubscriptionText_subscription__4k-OW","title":"SubscriptionText_title__GyidZ","subtitle":"SubscriptionText_subtitle__nkqDF","rtl":"SubscriptionText_rtl__NT4bR"};